import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, catchError, exhaustMap } from 'rxjs/operators';
import * as actions from '@appStore/metering-points/actions';
import { ActionTypes, AgreementLinkLoad } from '@appStore/metering-points/actions';
import { AgreementService } from '@appStore/metering-points/services/agreement.service';

@Injectable()
export class AgreementEffects {
    constructor(private agreementService: AgreementService, private actions$: Actions) {}

    createTaxReturnAgreement$ = createEffect(() => {
        return this.actions$.pipe(
          ofType(ActionTypes.CreateTaxReturnAgreement),
          exhaustMap((action: actions.CreateTaxReturnAgreement) => {
            return this.agreementService.createTaxReturnAgreement(action.payload).pipe(
              map(item => new actions.CreateTaxReturnAgreementSuccess(item)),
              catchError(error => of(new actions.CreateTaxReturnAgreementFail(error)))
            );
          })
        );
    });

    getAgreementLink$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(ActionTypes.AgreementLinkLoad),
            exhaustMap((action: AgreementLinkLoad) => {
                return this.agreementService.getAgreementLink(action.agreementId).pipe(
                    map(link => new actions.AgreementLinkLoadSuccess(link)),
                    catchError(error => of(new actions.AgreementLinkLoadFail(error)))
                );
            })
        );
    });
}